module.exports = __webpack_public_path__ + "static/recycledall-d382a32b81c6a0ab8ddc94f6f8feca08.png";